import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { getApiBaseUrl } from '../apiBaseUrlFinder';

const VerifyHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) return;

    axios
      .put(`${getApiBaseUrl()}/verify?token=${token}`)
      .then(() => {
        localStorage.setItem('verified', 'true'); // set flag
        navigate('/', { replace: true });
      })
      .catch((err) => {
        localStorage.setItem(
          'verify-error',
          err?.response?.data?.message || 'Verification failed. Please try again.'
        );
        navigate('/', { replace: true });
      });

  }, []);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Account Verification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyHandler;
